import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
import { LastPositionContext } from "../../services/ClienteContext";
import NotificationsAlert from '../../services/NotificationsAlert';
import Conect from '../../../Api/Conect.js';
import pin from "../../assets/marker.png";
import "./styles.css";
import ModalSetBlock from "./Componentes/ModalSetBlock.jsx";
import ModalOpenMap from "./Componentes/ModalOpenMap.jsx";
import VehicleCard from "./Componentes/CardVehicles.jsx";
import { Marker } from '@react-google-maps/api';
import ModalEditHodo from './Componentes/ModalEditHodo.jsx';
import ModalEditNotification from './Componentes/ModalEditNotification.jsx';
import LoadingOverlayManager from '../../services/LoadingOverlayManager';


const Home = () => {
  const token = localStorage.getItem("restoken")
  const fusoUser = localStorage.getItem('resstateFuso')
  const id_cli = localStorage.getItem('resid_cli')
  const veicles_ids = localStorage.getItem('resveicles_id')
  const id_user = localStorage.getItem('resid')

  const LastPosiData = useContext(LastPositionContext);
  const history = useNavigate();

  const [dados, setDados] = useState(null)
  const [cliData, setCliData] = useState(null)
  const [isModalOpenBlock, setIsModalOpenBlock] = useState(false)
  const [centerPositions, setCenterPositions] = useState({ lat: -31.72978671059568, lng: -52.343938513840065, zoom: 13 })
  const [isModalOpenMaps, setIsModalOpenMaps] = useState(false)
  const [isModalOpenEditHodo, setIsModalEditHodo] = useState(false)
  const [isModalOpenEditNotification, setIsModalEditNotification] = useState(false)
  const [lastPosisitionData, setLastPosisitionData] = useState([])
  const [selectedPosition, setSelectedPosition] = useState(null)
  const [data, setData] = useState();
  const [odometer, setOdometer] = useState();
  const [idVehicle, setIdVehicle] = useState();
  const [positions, setPositions] = useState([])
  const [blockCommand, setBlockCommand] = useState([])
  // const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (token === null) {
      NotificationsAlert("warning", "Desconectado", "Faça login para continuar!")
      history("/login");
      return
    } else {
      getPositions()
      getCliInfos()
      setInterval(() => {
        getPositions()
      }, 30000);
    }
    // eslint-disable-next-line
  }, []);

  const handleOpenModalBlock = (command, vehicleId) => {
    setBlockCommand([command, vehicleId]);
    setIsModalOpenBlock(true);
  };

  const OpenLastPositions = async (data) => {
    LastPosiData.setLastPosiData(data)
    history("/lastPosi");
  }

  const OpenMap = async (data) => {
    setCenterPositions({ lat: data.latitude, lng: data.longitude, zoom: 19 })
    var dados = (<Marker
      position={{ lat: data.latitude, lng: data.longitude }}
      onClick={() => {
        setSelectedPosition(data)
        setCenterPositions({ lat: data.latitude, lng: data.longitude, zoom: 19 })
      }}
      options={{
        label: {
          text: `${data.plate}`,
          className: "map-marker"
        }
      }}
      icon={{
        url: pin,
        scaledSize: new window.google.maps.Size(35, 35)
      }}
    />)
    setPositions(dados)
    setIsModalOpenMaps(true)
    const response = await Conect.post(`/dG9kYXlwb3NpdGlvbnN2ZWhpY2xl${token}`, {
      id: data.idVehicle
    })

    if (response.data.erro === true) {
      NotificationsAlert("warning", "Atenção", response.data.msg)

    } else {

      var lastdata = response?.data?.vehiclePosition.map((value, index) => {
        return (<Marker
          key={index}
          position={{ lat: value.latitude, lng: value.longitude }}
          options={{
            label: {
              text: `${value.plate}`,
              className: "map-marker"
            }
          }}
          icon={{
            url: pin,
            scaledSize: new window.google.maps.Size(35, 35)
          }}
        />)
      })
      setLastPosisitionData(lastdata)

    }
  }

  const handleCloseModalBlock = () => {
    setIsModalOpenBlock(false);
  };

  const handleCloseModalMaps = () => {
    setIsModalOpenMaps(false);
  };

  const handleCloseEditHodo = () => {
    setIsModalEditHodo(false);
  };

  const handleCloseEditNotification = () => {
    setIsModalEditNotification(false);
  };

  const getPositions = async () => {
    // if (!loaded) {
    //   LoadingOverlayManager.show();
    //   setLoaded(true)
    // }
    const response = await Conect.post(`/dmVoaWNsZXNVc2Vy${token}`, {
      vehicleIds: veicles_ids,
      id_cli: id_cli
    })
    // eslint-disable-next-line
    if (response.data.erro === true) {
      LoadingOverlayManager.hide();
      NotificationsAlert("warning", "Atenção", response.data.msg)
    }
    else {
      // eslint-disable-next-line
      LoadingOverlayManager.hide();
      setDados(response.data.positionsVehicles)
    }
  }

  const getCliInfos = async () => {
    const response = await Conect.post(`/aW5mb2NsaWVudGU=${token}`, {
      id: id_cli
    })

    // eslint-disable-next-line
    if (response.data.erro === true) {
      NotificationsAlert("warning", "Atenção", response.data.msg)
    }
    else {
      setCliData(response.data.data)
      // eslint-disable-next-line
    }
  }

  const showEditingHodo = async (data, id_vehicle) => {
    setOdometer(data)
    setIdVehicle(id_vehicle.idVehicle)
    setIsModalEditHodo(true)
  }

  const showEditingNotification = async (vehicleId) => {
    const response = await Conect.post(`/Z2V0Tm90aWZpY2F0aW9uc1ZlaGljbGVXaGVyZUlk`, {
      idVehicle: vehicleId
    })
    // eslint-disable-next-line
    if (response.data.erro === true) {
      NotificationsAlert("warning", "Atenção", response.data.msg)
    }
    else {
      // eslint-disable-next-line
      setIdVehicle(vehicleId)
      setData(response.data.notification)
      setIsModalEditNotification(true)
    }
  }

  return (
    <div>
      <ModalSetBlock
        isOpen={isModalOpenBlock}
        onClose={handleCloseModalBlock}
        getPositions={getPositions}
        token={token}
        id_user={id_user}
        blockCommand={blockCommand}
      />

      <ModalOpenMap
        isOpen={isModalOpenMaps}
        onClose={handleCloseModalMaps}
        centerPositions={centerPositions}
        positions={positions}
        fusoUser={fusoUser}
        selectedPosition={selectedPosition}
        lastPosisitionData={lastPosisitionData}
      />

      <ModalEditHodo
        isOpen={isModalOpenEditHodo}
        onClose={handleCloseEditHodo}
        odometer={odometer}
        idVehicle={idVehicle}
        setOdometer={setOdometer}
        getPositions={getPositions}
        token={token}
      />

      <ModalEditNotification
        isOpen={isModalOpenEditNotification}
        onClose={handleCloseEditNotification}
        showEditingNotification={showEditingNotification}
        data={data}
        token={token}
        idVehicle={idVehicle}
        id_user={id_user}
      />

      {cliData != null &&
        <p className="list-info-cli">
          <strong style={{ marginRight: 5 }}>Cliente: </strong> {cliData.name}
          <strong style={{ marginLeft: '5%', marginRight: 5 }}>Cidade: </strong> {cliData.city} - {cliData.state}
          <strong style={{ marginLeft: '5%', marginRight: 5 }}>Atualizado: </strong> {moment().format('DD/MM/yy - HH:mm:ss')}
        </p>
      }
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {dados != null && dados.map((vehicle, index) => (
          <VehicleCard
            key={index}
            vehicleData={vehicle}
            fusoUser={fusoUser}
            OpenMap={OpenMap}
            handleOpenModalBlock={handleOpenModalBlock}
            OpenLastPositions={OpenLastPositions}
            showEditingHodo={showEditingHodo}
            showEditingNotification={showEditingNotification}
          />
        ))}
      </div>
    </div>
  );
}

export default Home;